import { CalendarRow } from './types'

const Periods: CalendarRow = {
  id: 'periods',
  value: 'Periods',
}

const Weeks: CalendarRow = {
  id: 'weeks',
  value: 'Week No. W/C Sun / Wed',
}

const WeekDays: CalendarRow = { id: 'weekDays', value: 'Week Days' }

const Date: CalendarRow = { id: 'date', value: 'Date' }

const AvgTemp: CalendarRow = { id: 'avgTemp', value: 'Avg Temp (LY)' }

const Clothing: CalendarRow = { id: 'clothing', value: 'Clothing POS Cycles' }

const GM: CalendarRow = { id: 'GM', value: 'GM Cycles' }

const FFP: CalendarRow = { id: 'FFP', value: 'Group 1 Cycles' }

const IPSBC: CalendarRow = {
  id: 'IPSBC',
  value: 'Group 2A Cycles',
}

const BHBP: CalendarRow = {
  id: 'BHBP',
  value: 'Group 2B Cycles',
}

const HBC: CalendarRow = { id: 'HBC', value: 'Group 3 Cycles' }

export default {
  Periods,
  Weeks,
  WeekDays,
  Date,
  AvgTemp,
  FFP,
  IPSBC,
  BHBP,
  HBC,
  Clothing,
  GM,
}
